export default "__VITE_ASSET__pCLvzConCfU9AYu6FztHtg__"